/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsSupplier
 */
export interface MelcoModelsSupplier {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsSupplier
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsSupplier
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsSupplier
     */
    supplier_type?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsSupplier
     */
    publish_state: number;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsSupplier
     */
    created_date: Date;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsSupplier
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsSupplier
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsSupplier
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
}

export function MelcoModelsSupplierFromJSON(json: any): MelcoModelsSupplier {
    return MelcoModelsSupplierFromJSONTyped(json, false);
}

export function MelcoModelsSupplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsSupplier {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'supplier_type': !exists(json, 'supplier_type') ? undefined : json['supplier_type'],
        'publish_state': json['publish_state'],
        'created_date': (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
    };
}

export function MelcoModelsSupplierToJSON(value?: MelcoModelsSupplier | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'supplier_type': value.supplier_type,
        'publish_state': value.publish_state,
        'created_date': (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
    };
}


